export var NotificationVariant;
(function (NotificationVariant) {
    NotificationVariant["Error"] = "error";
    NotificationVariant["Warning"] = "warning";
    NotificationVariant["Success"] = "success";
    NotificationVariant["Promo"] = "promo";
    NotificationVariant["Reminder"] = "reminder";
})(NotificationVariant || (NotificationVariant = {}));
